export default defineNuxtPlugin(async () => {
    const route = useRoute();
    const frameNumber = unArray(route.query[TRACEABILITY_KEY]);

    if (frameNumber) {
        localStorage.setItem(TRACEABILITY_KEY, frameNumber);
    }
});
